import React from 'react';
import './scills.sass';
import { Line } from '../../../line/line';
import { ScillsAll } from './scillsAll';
import { Quotes } from '../../../quotes/quotes';
//@ts-ignore
// import { Progress } from 'react-sweet-progress';
// import "react-sweet-progress/lib/style.css";

export const Scills = () => {
    return (
        <>
            <div className="Scills">
                <div>
                    {/* Scills */}
                    <h2 id="Scills_h2">Мои навыки</h2>
                    <Line />
                </div>
                
                <div className="scillsProgress">
                    <ScillsAll />
                </div>
            </div>
            <div className="quotesSkills">
                <Quotes text="Большинство хороших программистов делают 
                свою работу не потому, что ожидают оплаты или признания,
                а потому что получают удовольствие от программирования."
                    author="«Linus Torvalds»" />
            </div>
        </>
        )
}